export default {
    // DADOS BASICOS
    // nao listado no doc
    codigo: {
        title: 'Código',
        type: 'text',
    },
    nome_programa: {
        title: 'Nome',
        type: 'text',
    },
    categorias_do_programa: {
        title: 'Objeto',
        type: 'textarea',
    },
    descricao: {
        title: 'Descrição',
        type: 'textarea',
    },
    tipo_instrumento: {
        title: 'Tipo do Instrumento',
        type: 'select',
    },
    qualificacao_da_proposta: {
        title: 'Qualificação da Proposta',
        type: 'checkbox',
    },
    // nao listado no doc
    imagem: {
        title: 'Logo/Tipo Imagem',
        type: 'file',
    },
    // Quem se destina
    programa_atende_a: {
        title: 'Natureza jurídica',
        type: 'checkbox',
    },
    estados_habilitados: {
        title: 'Estados',
        type: 'estados_habilitados',
    },
    // Condições de Participação
    criterios: {
        title: 'Critérios',
        type: 'textarea',
    },
    observacao: {
        title: 'Outras informações',
        type: 'textarea',
    },
    // Cronograma da Oportunidade
    data_disponibilizacao: {
        title: 'Data de Disponibilização',
        type: 'date',
    },
    voluntaria_data_inicio: {
        title: 'Data Inicio da proposta',
        type: 'date',
    },
    data_inicio_beneficiario_especifico: {
        title: 'Data Inicio da proposta',
        type: 'date',
    },
    emenda_data_inicio: {
        title: 'Data Inicio da proposta',
        type: 'date',
    },
    data_fim_beneficiario_especifico: {
        title: 'Data fim da proposta',
        type: 'date',
    },
    voluntaria_data_fim: {
        title: 'Data fim da proposta',
        type: 'date',
    },
    emenda_data_fim: {
        title: 'Data fim da proposta',
        type: 'date',
    },
    // FINAL DO MAPEAMENTO
    categorias: {
        title: 'Categorias',
        type: 'select',
    },
    qualificacao_propostas: {
        title: 'Qualificação da Proposta',
        type: 'checkbox',
    },
    // Condições de Participação
    outras_informacoes: {
        title: 'Outras informações',
        type: 'textarea',
    },
    // Submissão de Propostas
    plataforma_id: {
        title: 'Plataforma',
        type: 'select',
    },
    como_submeter_name: {
        title: 'Nome',
        type: 'text',
    },
    como_submeter_url: {
        title: 'URL',
        type: 'text',
    },
    como_submeter_descricao: {
        title: 'Descrição de como submeter',
        type: 'textarea',
    },
   // Cronograma da Oportunidade
    data_proposta_ini: {
        title: 'Data de Início das Propostas',
        type: 'date',
    },
    data_proposta_fim: {
        title: 'Data de Encerramento das Propostas',
        type: 'date',
    },
    data_proposta_fim_tipo: {
        title: 'Tipo de Encerramento',
        type: 'select',
    },
};
